import { Stack, Typography, Tooltip } from '@mui/material';
import { useListingColors } from 'legacyfrontend/hooks/useListingColors';
import formatSecondsToHours from 'legacyfrontend/utils/formatSecondsToHours';
import { getScaleInfo } from 'legacyfrontend/utils/getScaleInfo';
const TooltipScale = ({ escala }) => {
  const { background, coral } = useListingColors();

  const dotStyle = {
    height: 12,
    width: 12,
    borderRadius: '50%',
    backgroundColor: escala?.isNotScale ? background : coral,
    position: 'relative',
  };

  if (escala?.isNotScale) {
    return <div style={dotStyle} />;
  }

  const getTooltipInfo = (scale) => {
    if (!scale) return [];

    const formattedInfo = getScaleInfo(scale);

    return [
      { text: scale.origin },
      { text: `Tiempo de Espera: ${formatSecondsToHours(scale.waitTime)}` },
      {
        ...formattedInfo,
        color: '#009e00',
      },
    ];
  };

  const info = getTooltipInfo(escala);

  return (
    <Tooltip
      componentsProps={{
        tooltip: {
          sx: { backgroundColor: 'transparent !important' },
        },
      }}
      placement='top'
      title={
        <Stack className='tooltip-scale-container'>
          {info.map(({ text, color }, index) => (
            <Typography
              color={color || '#000'}
              fontSize={12}
              fontWeight={300}
              key={`scale-info-${index}`}
            >
              {text}
            </Typography>
          ))}
        </Stack>
      }
    >
      <div style={dotStyle} />
    </Tooltip>
  );
};

export default TooltipScale;
